import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useComputed, useObservable } from '@mybricks/rxui';
import { openPage, share, back, close } from '../utils/event';
import { getUrlParam, throttle } from '../utils';
import css from './runtime.less';
import React from 'react';
import { ComEnvContext, useComEnv } from '../utils/context';
declare global {
  interface Window {
    statusBarHeight: string;
  }
}

const ACTION_TO_HANS = {
  share: '分享',
  link: '链接跳转',
  refresh: '刷新',
  search: '搜索',
  diagram: '触发流程',
};
function refineSize(size) {
  return (size / 414) * window.innerWidth;
}

function ButtonBlock({ className = '', title = '', style = {}, statusBarHeight, isFixed = false }) {
  const { env, data, logger, outputs } = useComEnv();

  const leftClickParam = JSON.stringify([
    {
      triggerTime: 'CLICK',
      action: 'OP_ACTIVITY_BUTTON',
      params: {
        action_name: '返回',
      },
    },
  ]);

  const rightClickParam = JSON.stringify([
    {
      triggerTime: 'CLICK',
      action: 'OP_ACTIVITY_BUTTON',
      params: {
        action_name: ACTION_TO_HANS[data.rightButtonType],
      },
    },
  ]);

  const onLeftClick = useCallback(() => {
    if (data.backDelegate) {
      outputs['leftClick']();
    } else {
      back(env.yoda);
    }
  }, [env.yoda]);

  const onRightClick = useCallback(() => {
    switch (data.rightButtonType) {
      case 'share': {
        share(env, logger);
        break;
      }
      case 'link': {
        openPage(data.rightJumpUrl, env.yoda);
        break;
      }
      case 'refresh': {
        location.reload();
        break;
      }
      case 'search': {
        outputs['rightClick']();
      }
      case 'diagram': {
        outputs['rightClick']();
      }
      default: {
        break;
      }
    }
  }, []);

  return (
    <div
      className={`${css.buttonBlock} ${className}`}
      style={{
        ...style,
        marginTop: statusBarHeight + 'px',
        height: data.buttonBlockHeight + 'px',
      }}
    >
      <div
        className={css.leftButtonWrapper}
        style={{
          width: data.buttonSize + 'px',
          height: data.buttonSize + 'px',
        }}
      >
        <img
          className={css.leftButton}
          src={isFixed && data.diffFixedImg ? data.fixedLeftImg : data.leftImg}
          data-weblogger={leftClickParam}
          onClick={onLeftClick}
        ></img>
      </div>

      {title ? (
        <div className={css.title} style={{ height: data.buttonBlockHeight + 'px' }}>
          {title}
        </div>
      ) : null}

      <div
        className={css.rightButtonWrapper}
        style={{
          // width: data.buttonSize + 'px',
          height: data.buttonSize + 'px',
        }}
      >
        {data.rightButtonType !== 'none' ? (
          <img
            className={css.rightButton}
            src={isFixed && data.diffFixedImg ? data.fixedRightImg : data.rightImg}
            data-weblogger={rightClickParam}
            onClick={onRightClick}
          ></img>
        ) : null}
      </div>
    </div>
  );
}

export default function (props: RuntimeParams) {
  const { env, data, inputs, slots } = props;

  const model = useObservable({
    statusBarHeight: env.edit || !data.dynamicBarHeight ? 44 : parseInt(window.statusBarHeight),
    visible: false,
    opacity: 0,
  });

  useEffect(() => {
    if (!env.edit && data.dynamicBarHeight) {
      model.statusBarHeight = parseInt(window.statusBarHeight);
    }
    // url参数 isHalf 表示半屏页，去掉安全距离
    if (getUrlParam('isHalf') === 'true') {
      model.statusBarHeight = 0;
    }
  }, [data.dynamicBarHeight]);

  const onScroll = useCallback(() => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
    const offset = refineSize(data.offset);
    const rate = 0.5;

    //
    if (scrollTop > 5) {
      model.visible = true;
    } else {
      model.visible = false;
    }
    
    //
    if (scrollTop < offset * rate) {
      model.opacity = 0;
    } else if (scrollTop > offset) {
      model.opacity = 1;
    } else {
      model.opacity = scrollTop / (offset * rate) - 1;
    }
  }, []);

  inputs['title']((title) => {
    data.title = title;
  });

  useEffect(() => {
    if (data.type !== 'default') {
      window.addEventListener('scroll', onScroll, false);
      return () => {
        window.removeEventListener('scroll', onScroll, false);
      };
    }
  }, [data.type]);
  return (
    <ComEnvContext.Provider value={props}>
      {data.type === 'default' ? (
        <div className={css.baseTopBar} style={data.style}>
          <ButtonBlock title={data.title} style={data.buttonBlockStyle} statusBarHeight={model.statusBarHeight} />
        </div>
      ) : (
        <div className={css.fixedTopBar} style={{ display: model.visible ? 'block' : 'none' }}>
          {data.type !== 'customize' && (
            <ButtonBlock className={css.fixedButtonBlock} statusBarHeight={model.statusBarHeight} />
          )}

          <div
            className={css.topBlock}
            style={{
              ...data.style,
              opacity: env.edit && data.editVisible ? 1 : model.opacity,
            }}
          >
            {data.type !== 'customize' && (
              <ButtonBlock
                title={data.title}
                style={data.buttonBlockStyle}
                isFixed
                statusBarHeight={model.statusBarHeight}
              />
            )}
            {(data.type === 'with-slot' || data.type === 'customize') && (
              <div
                className={css.slot}
                style={{
                  height: slots['fixedSlot'].size ? undefined : '60px',
                  marginTop: data.type === 'customize' ? model.statusBarHeight + 'px' : undefined,
                }}
              >
                {slots?.['fixedSlot'].render()}
              </div>
            )}
          </div>
        </div>
      )}
    </ComEnvContext.Provider>
  );
}
